// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.e63bf9370',
  revision: 'e63bf9370',
  branch: 'develop',
  date: 'Thu, 03 Sep 2026 12:13:31 GMT'
};